import React from 'react';
import PropTypes from 'prop-types';
import { Masks, C, Sum, retrievePrecisionNumber, T } from 'shared/helpers';

import Styles from './Comp.module.scss';
import { calculateTotalNutrienteProdutos } from 'shared/business';

const { number, currency } = Masks;

export default function Comp({ produtos, tableKey, renderables, etapaIndex }) {
  const { Comp, Row, Produto, Total, Darker, m100, w100 } = Styles;
  let rowCount = 0;
  const k = () => `${tableKey}_comp_row${++rowCount}`;

  return (
    <div className={Comp}>
      {produtos.map((produto, index) => [
        <div
          key={k()}
          className={C(
            Row,
            [
              T(produto) &&
                !Number(T(produto).quantidade),
              Styles.Warning,
            ],
            [produto && !Number(produto.valor), Styles.Error],
          )}
        >
          {renderables.map((nutrient) => [
            <div
              key={k()}
              className={C(Produto, Styles.CompHighlight)}
              id={`etapa_${etapaIndex}_produto_${index}_${nutrient}`}
            >
              {number((produto[nutrient] / 100) * produto.quantidade, {
                ed: retrievePrecisionNumber(nutrient),
              })}
            </div>,
          ])}

          <div className={m100}>
            <div
              className={C(Produto, w100, [
                produto && !Number(produto.valor),
                Styles.Error,
              ])}
              id={`etapa_${etapaIndex}_produto_${index}_valor`}
            >
              {`${currency(produto.valor, { mind: 0, maxd: 0 })}`}
            </div>
            <div className={C(Total, Darker, w100)} />
            <div className={C(Total, Darker, w100)} />
          </div>
          <div className={m100}>
            <div
              className={C(Produto, w100)}
              id={`etapa_${etapaIndex}_produto_${index}_produto_quantidade`}
            >
              {`${currency((produto.valor / 1000) * produto.quantidade, {
                ed: 0,
              })} /ha`}
            </div>
            <div className={C(Total, w100)}>
              {`${currency(
                produtos.map((x) => (x.valor / 1000) * x.quantidade),
                { ed: 0 },
              )} /ha`}
            </div>
            <div className={C(Total, Darker, w100)} />
          </div>
        </div>,
        <div key={k()} className={Row}>
          {renderables.map(
            // For each renderable
            (nutrient, indexRenderable) => (
              <div key={k()}>
                {' '}
                {/** Render a div */}
                {index === produtos.length - 1 && [
                  // If the product is the last one
                  <div key={k()} className={Total}>
                    {' '}
                    {/** Render the total  */}
                    {calculateTotalNutrienteProdutos(produtos, nutrient)}
                  </div>,
                  (indexRenderable < 3 && (
                    <div key={k()} className={Total}>
                      {number(
                        Sum(
                          produtos.map(
                            (produto) =>
                              (produto[nutrient] / 100) * produto.quantidade,
                          ),
                        ) /
                          Sum(
                            produtos.map(
                              (produto) =>
                                (produto.N / 100) * produto.quantidade,
                            ),
                          ),
                      )}
                    </div>
                  )) || <div key={k()} className={C(Total, Darker)} />,
                ]}
              </div>
            ),
          )}
        </div>,
      ])}
      {!produtos.length && (
        <>
          <div key={k()} className={Row}>
            {renderables.map((r) => (
              <div key={k()} className={Total}>
                {Masks.number(0, { ed: retrievePrecisionNumber(r) })}
              </div>
            ))}
            <div key={k()} className={C(Total, w100)}>
              {Masks.number(0, { ed: 2 })}
            </div>
            <div key={k()} className={C(Total, w100)}>
              {Masks.currency(0, { ed: 0, suffix: ' /ha' })}
            </div>
          </div>
          <div key={k()} className={Row}>
            {renderables.map(() => (
              <div key={k()} className={C(Total, Darker)} />
            ))}
            <div key={k()} className={C(Total, w100, Darker)} />
            <div key={k()} className={C(Total, w100, Darker)} />
          </div>
        </>
      )}
    </div>
  );
}

Comp.defaultProps = {};

Comp.propTypes = {
  tableKey: PropTypes.string.isRequired,
  produtos: PropTypes.any.isRequired,
  renderables: PropTypes.arrayOf(PropTypes.string).isRequired,
  etapaIndex: PropTypes.number.isRequired,
};
